import { useForm } from "react-hook-form";

import { Col, Row } from "react-bootstrap";
import RenderField from "../RenderField";
import { Button, Typography } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setOtherAttachments } from "../../store/slice/application";
import {  useState } from "react";

const Attachments = ({ register, errors, toggle, watch }) => {
  const [rwanda, setRwanda] = useState(watch("nationality") === "Rwanda");

  const dispatch = useDispatch();

  const { otherAttachments } = useSelector((state) => state.application);

  return (
    <div className="w-full">
      <p className={"text-center p-4 text-3xl font-light"}>
        Upload all Neccessary Documents
      </p>
      <Row>
        <Col md={6}>
          <RenderField
            label={rwanda ? "NID" : "Passport"}
            type={"file"}
            className={"form-control"}
            placeholder={"C.V"}
            name={"nidAttachment"}
            required={true}
            register={register}
            errors={errors}
          />
        </Col>
        <Col md={6}>
          <RenderField
            label={"CV"}
            type={"file"}
            className={"form-control"}
            placeholder={"C.V"}
            name={"cv"}
            required={true}
            register={register}
            errors={errors}
          />
        </Col>
      </Row>

      <div className="pt-4  ">
        <div>
          <Button
            style={{ backgroundColor: "#054163" }}
            color={"secondary"}
            startIcon={<AttachFile />}
            onClick={() => {
              toggle();
            }}
            variant={"contained"}
          >
            Degree/Certificates, ETC..
          </Button>
        </div>
        <div>
          {otherAttachments.length <= 0 ? (
            <div className={"text-center p-3"}>
              <i
                className="bi bi-info-circle-fill"
                style={{ fontSize: "40px" }}
              ></i>
              <div>
                <Typography>No Documents added yet</Typography>
              </div>
              <div className={"mt-2"} style={{ fontStyle: "italic" }}>
                <Typography>
                  Upload academic and other professional certificates
                </Typography>
              </div>
            </div>
          ) : (
            <div className={"overflow-hidden"}>
              <table className={"table table-striped w-full"}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {otherAttachments.map((v, index) => (
                    <tr>
                      <td>{v.name}</td>
                      <td>
                        <button
                          className={"btn btn-sm btn-danger float-end"}
                          onClick={() => {
                            dispatch(
                              setOtherAttachments(
                                otherAttachments.filter(
                                  (item, i) => item.name !== v.name
                                )
                              )
                            );
                          }}
                        >
                          <i className={"bi bi-trash"}></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Attachments;
